import { createContext, PropsWithChildren, useContext } from 'react';

import { ServiceContractPosition } from '@work4all/models/lib/Classes/ServiceContractPosition.entity';

import { useShadowServiceContractObjectApi } from './use-shadow-service-contract-object-api';

type ReturnUseShadowServiceContractObjectApi = ReturnType<
  typeof useShadowServiceContractObjectApi
>['1'];

interface ShadowServiceContractObjectApi
  extends ReturnUseShadowServiceContractObjectApi {
  positions: ServiceContractPosition[];
  // deleteShadowObject: () => Promise<any>;
}

interface ShadowServiceContractObjectApiContextProviderProps {
  value: ShadowServiceContractObjectApi;
}

const ShadowServiceContractObjectApiContext =
  createContext<ShadowServiceContractObjectApi | null>(null);

export const ShadowServiceContractObjectApiContextProvider = (
  props: PropsWithChildren<ShadowServiceContractObjectApiContextProviderProps>
) => {
  const { children, value } = props;
  return (
    <ShadowServiceContractObjectApiContext.Provider value={value}>
      {children}
    </ShadowServiceContractObjectApiContext.Provider>
  );
};

export const useShadowServiceContractObjectApiContext = () => {
  const state = useContext(ShadowServiceContractObjectApiContext);
  if (!state) {
    throw new Error(
      'Context is null. Make sure you wrapped your component with <ShadowServiceContractObjectApiContext />'
    );
  }
  return state;
};
